function Banner({ destinations }) {
  return (
    <div className="banner">
      <div className="bannerContent">
        <img className="img-fluid" src={destinations.image} alt="" />
        <h5 className="title">{destinations.name}</h5>
      </div>
    </div>
  );
}
export default Banner;
